<ng-container *ngIf="player.cued()">
    <player-seekbar></player-seekbar>

    <div class="controls">
        <button class="no-style maximize" (click)="overlay.maximize()"><mat-icon svgIcon="keyboard-arrow-up"></mat-icon></button>
        <div class="track-info">
            <div class="track-name">{{player.getCuedTrack().name}}</div>
            <artists-links-list class="artist-name" [artists]="player.getCuedTrack()?.artists"></artists-links-list>
        </div>
        <main-playback-buttons></main-playback-buttons>
    </div>
</ng-container>

<custom-menu position="mobile-bottom" class="nav">
    <button type="button" class="no-style nav-item custom-menu-item" (click)="openUserMenuSheet()">
        <mat-icon svgIcon="person"></mat-icon>
        <span class="text" trans>Account</span>
    </button>
</custom-menu>

<mat-menu></mat-menu>
